import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserGroup = (id, enabled = true) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['userGroup', id],
    queryFn: async () => {
      const result = await restClient({
        url: `${prefix}/user-groups/${id}`,
        method: 'get'
      });
      return result;
    },
    enabled: enabled && !!id, 
    staleTime: 0, 
    cacheTime:0, 
    refetchOnWindowFocus: false
  });
};
